import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-45a56d7e")

_pushScopeId("data-v-45a56d7e")
const _hoisted_1 = { class: "form-container" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Back")
const _hoisted_6 = {
  key: 0,
  class: "buttons-container"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Save")
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Create")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form = _resolveComponent("el-form")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      ($setup.isReadOnly)
        ? (_openBlock(), _createBlock("h1", _hoisted_2, "Organization"))
        : ($setup.isEditing)
          ? (_openBlock(), _createBlock("h1", _hoisted_3, "Update Organization"))
          : (_openBlock(), _createBlock("h1", _hoisted_4, "New Organization")),
      (!$setup.isEditing)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 3,
            icon: "el-icon-arrow-left",
            onClick: $setup.routeBack,
            type: "info"
          }, {
            default: _withId(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true),
      _withDirectives(_createVNode(_component_el_form, {
        "element-loading-text": "Saving...",
        ref: "formRef",
        model: _ctx.form,
        rules: _ctx.rules,
        "status-icon": "",
        "label-width": "150px"
      }, {
        default: _withId(() => [
          _createVNode(_component_el_form_item, {
            label: "Name",
            prop: "name",
            required: ""
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.name = $event)),
                readonly: $setup.isReadOnly ? true : false
              }, null, 8, ["modelValue", "readonly"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "Address",
            prop: "address"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.address,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.address = $event)),
                readonly: $setup.isReadOnly ? true : false
              }, null, 8, ["modelValue", "readonly"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "Address Line 2",
            prop: "address2"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.address2,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.address2 = $event)),
                readonly: $setup.isReadOnly ? true : false
              }, null, 8, ["modelValue", "readonly"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "City",
            prop: "city"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.city,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.city = $event)),
                readonly: $setup.isReadOnly ? true : false
              }, null, 8, ["modelValue", "readonly"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "State",
            prop: "state"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.state,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.state = $event)),
                readonly: $setup.isReadOnly ? true : false
              }, null, 8, ["modelValue", "readonly"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "Country",
            prop: "country"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.country,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.country = $event)),
                readonly: $setup.isReadOnly ? true : false
              }, null, 8, ["modelValue", "readonly"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "Zip",
            prop: "zip"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.zip,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.form.zip = $event)),
                readonly: $setup.isReadOnly ? true : false
              }, null, 8, ["modelValue", "readonly"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "Main Phone",
            prop: "main_phone"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.main_phone,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.form.main_phone = $event)),
                readonly: $setup.isReadOnly ? true : false
              }, null, 8, ["modelValue", "readonly"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "US DOT #",
            prop: "us_dot_num"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.us_dot_num,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.form.us_dot_num = $event)),
                readonly: $setup.isReadOnly ? true : false
              }, null, 8, ["modelValue", "readonly"])
            ]),
            _: 1
          }),
          ($setup.isVAR || $setup.isSuperAdmin)
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                label: "RoadReady Template",
                class: "full-width",
                loading: _ctx.templateFetchState !== $setup.FetchStates.FETCHED
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.form.templates_id,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.form.templates_id = $event)),
                    placeholder: "Select Template",
                    filterable: "",
                    class: "full-width"
                  }, {
                    default: _withId(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.templateList, (template) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: template.id,
                          label: template.name,
                          value: template.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["loading"]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, null, {
            default: _withId(() => [
              (!$setup.isReadOnly)
                ? (_openBlock(), _createBlock("div", _hoisted_6, [
                    ($setup.isEditing)
                      ? (_openBlock(), _createBlock("div", _hoisted_7, [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            onClick: $setup.saveOrg
                          }, {
                            default: _withId(() => [
                              _hoisted_8
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_9, [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            onClick: $setup.saveOrg
                          }, {
                            default: _withId(() => [
                              _hoisted_10
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"]), [
        [_directive_loading, _ctx.saveState === $setup.FetchStates.FETCHING]
      ])
    ])
  ]))
})